import axios from "axios";

export const getIntegrationStatus = async () => {
  const { data } = await axios.get("/account/integration/status");
  return data;
};

export const postLanguage = async (language: string) => {
  await axios.post("/account/language/save", {
    language,
  });
};

export const postSmsSendSubscriptionTypeId = async (value: boolean) => {
  const { data } = await axios.post("/account/sms-send-subscription-type-id", {
    sms_send_subscription_type_id: value ? 4 : 1,
  });
  return data;
};

export const postWhatsappSendSubscriptionTypeId = async (value: boolean) => {
  const { data } = await axios.post("/account/whatsapp-send-subscription-type-id", {
    whatsapp_send_subscription_type_id: value ? 4 : 1,
  });
  return data;
};

export const getSmsSendSubscriptionTypeId = async () => {
  const { data } = await axios.get("/account/sms-send-subscription-type-id");
  return data;
};

export const getWhatsappSendSubscriptionTypeId = async () => {
  const { data } = await axios.get("/account/whatsapp-send-subscription-type-id");
  return data;
};

export const setTourCompleted = async () => {
  const { data } = await axios.put("/account/setTourCompleted");
  return data;
};
